import {
  React,
 
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  Link
} from '../libraries'
import logo from '../assets/images/logo2.svg'
import { 
  Col,
  Row,
  Container,
 } from 'react-bootstrap'

export const Footer = () => {
  return (
    <>
      <div className='line-custom' />
      <Col className='bg-white mb-0'>
        <Container className='container pt-5 pb-5'>
          <Col className='p-0 text-center'>
            <h3 className='text-orange pb-4'><b>PEMILU FEVCI</b></h3>
            {/* <p className='text-secondary mb-0'>
              Untuk menjadi anggota Ford Everest Club Indonesia, silahkan mengisi form pada halaman <Link to='/register'><span className='text-orange'>pendaftaran</span></Link>
            </p> */}
            {/* <p className='text-secondary mb-0'>Silahkan upload file excel peserta pemilih Ketum FEVCI 2020-2022</p> */}
            {/* <ButtonActions title='Register' /> */}
          </Col>
        </Container>
      </Col>
      <div className='footer-bottom-line' />
      <div className='footer-wrapper'>
        <Container>
          <Row>
            <Col lg={5} xs={12}>
              <img className='footer-logo mb-5' src={logo} width='320px' alt='img-logo' />
              <h5>Ford Everest Club Indonesia (FEVCI)</h5>
            </Col>
            <Col lg={1} xs={12} />
            <Col className='mt-5'>
              <h5>Menu</h5>
              <ul className='footer-menu'>
                <li><Link to='/'>Home</Link></li>
                <li><Link to='/about'>About FEvCI</Link></li>
                <li><Link to='/peraturan-pemilu'>Peraturan & Form Pemilu</Link></li>
                <li><Link to='/syarat-balon'>Syarat Balon Ketum</Link></li>
                {/* <li><Link to='/register'>Pendaftaran</Link></li> */}
              </ul>
            </Col>
            <Col lg={3} xs={12} className='mt-5'>
              <h5>Social Media</h5>
              <ul className='footer-menu'>
                <li><FaInstagram /> &nbsp;Instagram</li>
                <li><a href='https://www.facebook.com/groups/fevci' rel='noopener noreferrer' target='_blank'><FaFacebookF /> &nbsp;Facebook</a></li>
                <li><FaTwitter /> &nbsp;Twitter</li>
              </ul>
            </Col>
            {/* <Row>
            <Col xs={12} className='footer-border-top'>
              <p className='text-center text-copyright mt-3'>Copyright 2020 - Codelabs Indonesia</p>
            </Col>
          </Row> */}
          </Row>
        </Container>
      </div>
    </>
  )
}
